<section class="site-milestones-main-wrap" appIntersectionObserver>
    <div class="container">
        <div class="site-milestones-main">

            <div class="site-common-heading hidden delay-1">
                <h2 class="site-heading-h2">Milestones</h2>
            </div>



            <div class="site-milestones-content-columns">
                <div class="site-milestones-content hidden delay-2">
                    <div class="site-milestones-content-column-inner">
                        <div class="site-milestones-column-img">
                            <img src="images/svg/calendar.svg" alt="Calendar Icon">
                        </div>
                        <p class="site-text-p">6 years on the market</p>
                    </div>
                </div>
                <div class="site-milestones-content hidden delay-3">
                    <div class="site-milestones-content-column-inner">
                        <div class="site-milestones-column-img">
                            <img src="images/svg/users.svg" alt="Users Icon">
                        </div>
                        <p class="site-text-p">Thousands of satisfied customers worldwide</p>
                    </div>
                </div>
                <div class="site-milestones-content hidden delay-4">
                    <div class="site-milestones-content-column-inner">

                        <div class="site-milestones-column-img">
                            <img src="images/svg/file-check-icon.svg" alt="File-Check Icon">
                        </div>
                        <p class="site-text-p">Completed over 33k successful reports</p>
                    </div>
                </div>
                <div class="site-milestones-content hidden delay-5">
                    <div class="site-milestones-content-column-inner">
                        <div class="site-milestones-column-img">
                            <img src="images/svg/mobile.svg" alt="Mobile Icon">
                        </div>
                        <p class="site-text-p">More than 120K app downloads</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>